import { Button, HStack, Image } from 'tcm-chakra-ui'
import { FiExternalLink } from 'react-icons/fi'
import { generateAthenaEmrLink } from '../../features/tcm-workflow/utils/athenaLinks'
import athenaLogo from '../../assets/icons/athenahealth.webp'

type AthenaLinkButtonProps = {
  patientId?: string | null
  tableSpace?: string | null
  emrLink?: string | null
  athenaApiUrl?: string | null
  label?: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
}

export function AthenaLinkButton({
  patientId,
  tableSpace,
  emrLink,
  athenaApiUrl,
  label = 'Open in Athena',
  size = 'sm',
}: AthenaLinkButtonProps) {
  const directEmrUrl = emrLink?.trim() ?? ''
  const pid = patientId?.trim() ?? ''
  const ts = tableSpace?.trim() ?? ''
  const emrUrl =
    directEmrUrl ||
    (pid && ts
      ? generateAthenaEmrLink({
          patientId: pid,
          tableSpace: ts,
          athenaApiUrl,
        })
      : '')
  if (!emrUrl) return null

  const iconSizeMap: Record<NonNullable<AthenaLinkButtonProps['size']>, number> = {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
  }

  return (
    <Button
      size={size}
      px={3}
      py={2}
      borderRadius="md"
      bg="blue.500"
      color="white"
      _hover={{ bg: 'blue.600' }}
      _active={{ bg: 'blue.700' }}
      onClick={() => {
        window.open(emrUrl, '_blank', 'noopener,noreferrer')
      }}
      aria-label={`${label}: ${emrUrl}`}
      title={emrUrl}
    >
      <HStack gap={2} align="center">
        <Image
          src={athenaLogo}
          alt="Athenahealth"
          height="2rem"
          width="auto"
          objectFit="contain"
        />
        <FiExternalLink color="rgba(255, 255, 255, 0.82)" size={iconSizeMap[size] - 1} />
      </HStack>
    </Button>
  )
}

